import { z } from 'zod';

const SIX_DECIMALS = /^\d+(\.\d{1,6})?$/;

function qtySchema({ positive = false, message }) {
  return z.union([z.string(), z.number()]).refine((value) => {
    const text = String(value ?? '').trim();
    if (!SIX_DECIMALS.test(text)) {
      return false;
    }
    return positive ? Number(text) > 0 : Number(text) >= 0;
  }, { message });
}

const materialSchema = z.object({
  id: z.string().optional().nullable(),
  inventoryStockId: z.string().min(1, '請選擇庫存'),
  mtrId: z.string().optional().nullable(),
  unitId: z.string().min(1, '請選擇單位'),
  qty: qtySchema({ positive: true, message: '用量須大於 0，最多 6 位小數' }),
}).passthrough();

export const workOrderRepairFormSchema = z.object({
  problemQty: qtySchema({ positive: true, message: '問題數量須大於 0，最多 6 位小數' }),
  repairedQty: qtySchema({ message: '已修復數量須 ≥ 0，最多 6 位小數' }),
  notRepairedQty: qtySchema({ message: '不維修數量須 ≥ 0，最多 6 位小數' }),
  problemDescription: z.string().trim().min(1, '請填寫問題描述'),
  handlingDescription: z.string().optional().nullable(),
  remark: z.string().optional().nullable(),
  materials: z.array(materialSchema).default([]),
});

export const WORK_ORDER_REPAIR_FIELD_LABELS = {
  problemQty: '問題數量',
  repairedQty: '已修復數量',
  notRepairedQty: '不維修數量',
  problemDescription: '問題描述',
  handlingDescription: '處理描述',
  remark: '備註',
  materials: '用料',
  'materials.inventoryStockId': '用料庫存',
  'materials.unitId': '用料單位',
  'materials.qty': '用料數量',
};

export function resolveWorkOrderRepairFieldLabel(path) {
  if (WORK_ORDER_REPAIR_FIELD_LABELS[path]) {
    return WORK_ORDER_REPAIR_FIELD_LABELS[path];
  }
  const match = /^materials\.\d+\.(\w+)$/.exec(path ?? '');
  if (match) {
    return WORK_ORDER_REPAIR_FIELD_LABELS[`materials.${match[1]}`] ?? path;
  }
  return path;
}
